// -------------------- LAB ACTION TYPES --------------------
export const GET_PENDING_LABS = "GET_PENDING_LABS";
export const GET_PENDING_LABS_SUCCESS = "GET_PENDING_LABS_SUCCESS";
export const GET_PENDING_LABS_FAIL = "GET_PENDING_LABS_FAIL";

export const GET_APPROVED_LABS = "GET_APPROVED_LABS";
export const GET_APPROVED_LABS_SUCCESS = "GET_APPROVED_LABS_SUCCESS";
export const GET_APPROVED_LABS_FAIL = "GET_APPROVED_LABS_FAIL";

export const GET_UNAPPROVED_LABS = "GET_UNAPPROVED_LABS";
export const GET_UNAPPROVED_LABS_SUCCESS = "GET_UNAPPROVED_LABS_SUCCESS";
export const GET_UNAPPROVED_LABS_FAIL = "GET_UNAPPROVED_LABS_FAIL";

export const APPROVE_UNAPPROVE_LAB = "APPROVE_UNAPPROVE_LAB";
export const APPROVE_UNAPPROVE_LAB_SUCCESS = "APPROVE_UNAPPROVE_LAB_SUCCESS";
export const APPROVE_UNAPPROVE_LAB_FAIL = "APPROVE_UNAPPROVE_LAB_FAIL";

export const GET_SUSPENDED_LABS = "GET_SUSPENDED_LABS";
export const GET_SUSPENDED_LABS_SUCCESS = "GET_SUSPENDED_LABS_SUCCESS";
export const GET_SUSPENDED_LABS_FAIL = "GET_SUSPENDED_LABS_FAIL";

export const GET_ALL_PARTICIPANT = "GET_ALL_PARTICIPANT";
export const GET_ALL_PARTICIPANT_SUCCESS = "GET_ALL_PARTICIPANT_SUCCESS";
export const GET_ALL_PARTICIPANT_FAIL = "GET_ALL_PARTICIPANT_FAIL";

// -------------------- B2B ACTION TYPES --------------------
export const GET_PENDING_B2B_CLIENTS = "GET_PENDING_B2B_CLIENTS";
export const GET_PENDING_B2B_CLIENTS_SUCCESS =
  "GET_PENDING_B2B_CLIENTS_SUCCESS";
export const GET_PENDING_B2B_CLIENTS_FAIL = "GET_PENDING_B2B_CLIENTS_FAIL";

export const GET_APPROVED_B2B_CLIENTS = "GET_APPROVED_B2B_CLIENTS";
export const GET_APPROVED_B2B_CLIENTS_SUCCESS =
  "GET_APPROVED_B2B_CLIENTS_SUCCESS";
export const GET_APPROVED_B2B_CLIENTS_FAIL = "GET_APPROVED_B2B_CLIENTS_FAIL";

export const GET_UNAPPROVED_B2B_CLIENTS = "GET_UNAPPROVED_B2B_CLIENTS";
export const GET_UNAPPROVED_B2B_CLIENTS_SUCCESS =
  "GET_UNAPPROVED_B2B_CLIENTS_SUCCESS";
export const GET_UNAPPROVED_B2B_CLIENTS_FAIL =
  "GET_UNAPPROVED_B2B_CLIENTS_FAIL";

export const APPROVE_UNAPPROVE_B2B_CLIENT = "APPROVE_UNAPPROVE_B2B_CLIENT";
export const APPROVE_UNAPPROVE_B2B_CLIENT_SUCCESS =
  "APPROVE_UNAPPROVE_B2B_CLIENT_SUCCESS";
export const APPROVE_UNAPPROVE_B2B_CLIENT_FAIL =
  "APPROVE_UNAPPROVE_B2B_CLIENT_FAIL";

export const UPDATE_MEMBERSHIP_STATUS = "UPDATE_MEMBERSHIP_STATUS";
export const UPDATE_MEMBERSHIP_STATUS_SUCCESS =
  "UPDATE_MEMBERSHIP_STATUS_SUCCESS";
export const UPDATE_MEMBERSHIP_STATUS_FAIL = "UPDATE_MEMBERSHIP_STATUS_FAIL";
//////////////////////////////////////////
export const UPDATE_LABS = "UPDATE_LABS";
export const UPDATE_LABS_SUCCESS = "UPDATE_LABS_SUCCESS";
export const UPDATE_LABS_FAIL = "UPDATE_LABS_FAIL";
///////////////DELETE LABS///////////
export const GET_DELETE_PARTICIPANT = "DELETE_PARTICIPANT";
export const GET_DELETE_PARTICIPANT_SUCCESS = "DELETE_PARTICIPANT_SUCCESS";
export const GET_DELETE_PARTICIPANT_FAIL = "DELETE_PARTICIPANT_FAIL";

//////////////////////////////////////
export const GET_PART_PAYMENT = "GET_PART_PAYMENT";
export const GET_PART_PAYMENT_SUCCESS = "GET_PART_PAYMENT_SUCCESS";
export const GET_PART_PAYMENT_FAIL = "GET_PART_PAYMENT_FAIL";

//////////////////////////////////////////
export const ADD_REMAINING_PAYMENT = "ADD_REMAINING_PAYMENT";
export const ADD_REMAINING_PAYMENT_SUCCESS = "ADD_REMAINING_PAYMENT_SUCCESS";
export const ADD_REMAINING_PAYMENT_FAIL = "ADD_REMAINING_PAYMENT_FAIL";

export const GET_ALL_DELETED_PARTICIPANT = "GET_ALL_DELETED_PARTICIPANT";
export const GET_ALL_DELETED_PARTICIPANT_SUCCESS =
  "GET_ALL_DELETED_PARTICIPANT_SUCCESS";
export const GET_ALL_DELETED_PARTICIPANT_FAIL =
  "GET_ALL_DELETED_PARTICIPANT_FAIL";
